<section id="entity-container">
  <h2>What record type do you want this template for?</h2>
  @if (loadingEntities) {
    <app-skeleton [style]="'word-entity-selection'" [count]="4"></app-skeleton>
  }
  <div class="scrollable-container">
    @for (entity of entities$ | async; track entity.entity) {
      <button class="entity-selection-toggle" [title]="entity.entity" (click)="onEntityClick(entity)" matRipple @entityButtonsAppear>
        @if (entity.properties?.iconUrl; as iconUrl) {
          <app-salesforce-entity-icon
            [entityType]="entity.entity"
            [iconUrl]="iconUrl"
            [iconColor]="entity.properties?.iconColor"
            [iconClass]="(getIcon(entity.entity) ?? '') + ' word-entity-icon'"
            imgClass="entity-icon-img word-entity-icon">
          </app-salesforce-entity-icon>
          {{ entity.label }}
          <app-salesforce-entity-icon
            [entityType]="entity.entity"
            [iconUrl]="iconUrl"
            [iconColor]="entity.properties?.iconColor"
            [renderAsWatermark]="true"
            [iconClass]="(getIcon(entity.entity) ?? '') + ' watermark word-entity-watermark'"
            imgClass="entity-icon-img watermark word-entity-watermark">
          </app-salesforce-entity-icon>
        } @else {
          <i [ngClass]="getIcon(entity.entity) ?? ''"></i>
          {{ entity.label }}
          <i [ngClass]="(getIcon(entity.entity) ?? '') + ' watermark'"></i>
        }
      </button>
    }
  </div>
</section>
